const news = () => {
    if ($(".news-list").length) {
        $('.blog-item .group-image').mouseover(function() {
            $(this).parents('.blog-item').find('.group-content .title').addClass('active');
        });

        $('.blog-item .group-image').mouseout(function() {
            $(this).parents('.blog-item').find('.group-content .title').removeClass('active');
        });
    }

    if ($(".new-detail").length) {
        $('.related-posts img').mouseover(function() {
            $(this).parents('.related-posts').find('.blue.rio-h3').addClass('active');
        });

        $('.related-posts img').mouseout(function() {
            $(this).parents('.related-posts').find('.blue.rio-h3').removeClass('active');
        });
    }
}

module.exports = news
